import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Gift } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const opts = { withCredentials: true };

export const AdminGiftCards = () => {
  const { toast } = useToast();
  const [cards, setCards] = useState([]);
  const load = useCallback(async () => {
    try { setCards((await axios.get(`${API}/gift-cards/admin`, opts)).data); } catch { /* ignore */ }
  }, []);
  useEffect(() => { load(); }, [load]);

  const redeem = async (code) => {
    if (!window.confirm(`Mark ${code} as used?`)) return;
    try { await axios.post(`${API}/gift-cards/admin/${code}/redeem`, {}, opts); toast({ title: 'Gift card marked as used' }); load(); }
    catch { toast({ title: 'Could not update', variant: 'destructive' }); }
  };

  return (
    <section data-testid="admin-gift-cards-section" className="pb-20 max-w-[1200px] mx-auto px-8">
      <p className="text-[11px] tracking-[0.3em] text-[#8B7FB8] font-medium mb-3 flex items-center gap-2"><Gift size={13} /> GIFT CARDS</p>
      <h2 className="font-serif text-4xl text-[#1E1B18] mb-6">Gift cards sold</h2>
      {cards.length === 0 ? (
        <div data-testid="admin-gift-cards-empty" className="text-[14px] text-[#1E1B18]/60 py-12 text-center border border-dashed border-[#1E1B18]/15 rounded-sm bg-[#FBF7F0]">No gift cards sold yet.</div>
      ) : (
        <div className="space-y-3">
          {cards.map((c) => (
            <div key={c.gift_card_id} data-testid={`admin-gift-card-${c.code}`} className="bg-[#FBF7F0] border border-[#1E1B18]/8 rounded-sm p-5 flex flex-col md:flex-row md:items-center gap-4">
              <div className="flex-1 min-w-0 text-[13px] text-[#1E1B18]/70">
                <div className="flex items-center gap-3 mb-1">
                  <span className="font-mono text-[14px] text-[#1E1B18]">{c.code}</span>
                  <span className="text-[15px] font-medium text-[#1E1B18]">${c.amount}</span>
                  <span className="text-[10px] tracking-[0.15em] uppercase px-2.5 py-0.5 rounded-full bg-[#E5DDF0] text-[#8B7FB8]">{c.status}</span>
                </div>
                For {c.recipient_name} · from {c.sender_name} ({c.sender_email}) · {(c.paid_at || c.created_at).slice(0, 10)}
              </div>
              {c.status === 'active' && (
                <button data-testid={`admin-gift-redeem-${c.code}`} onClick={() => redeem(c.code)}
                  className="shrink-0 bg-[#0F0E0C] hover:bg-[#2A2622] text-[#F4EFE7] px-4 py-2 rounded-full text-[12px] font-medium transition-colors">Mark as used</button>
              )}
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
